import Vue from "vue";

// eslint-disable-next-line
import EventBus from "./eventBus.js";

Vue.prototype.$eventBus = EventBus;

Vue.config.errorHandler = function () {
  // Do nothing. Overlay will not show.
};

import store from "./store";
import router from "./router";

import dayjs from "dayjs";
var updateLocale = require("dayjs/plugin/updateLocale");
dayjs.extend(updateLocale);

import pluralize from "pluralize";

/**
 *  Global/Common V3 components.
 *  ----------------------------
 *  Anything in: ./components/_v3.3/_common will be available
 *  -----------
 *  Examples:
 *   - ./Loading.vue
 */

// var confetti = require('canvas-confetti');

// eslint-disable-next-line
import confetti from "canvas-confetti";

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

const requireComponent = require.context(
  // The relative path of the components folder
  "./components/_v3.3/_common",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

/**
 *  END GLOBAL LOADER..........
 */

// import axios from 'axios';

// REMOVED (July 2023) -- slow and no-one looks at it anyway! ... if re-added, sample or exclude GoogleBot!
// import 'app/handlers/bugsnag/bugsnag'
import App from "./App";

import DomPortal from "vue-dom-portal";
Vue.use(DomPortal);

// var infiniteScroll =  require('vue-infinite-scroll');
// Vue.use(infiniteScroll);

import VueSmoothScroll from "vue2-smooth-scroll";
Vue.use(VueSmoothScroll);

import Loader from "./components/Loader";
Vue.component("global-loader", Loader);

import Header from "./modules/Header";
Vue.component("global-header", Header);

// import Header from './components/_v5/base/Header'
// Vue.component('global-header', Header);

import Modal from "./components/Modal";
Vue.component("global-modal", Modal);

import SVG from "./components/SVG";
Vue.component("global-svg", SVG);

import v5SVG from "./components/_v5/SVG";
Vue.component("base-svg", v5SVG);

import Social from "./components/Social";
Vue.component("global-social", Social);

// Swiper element for stories
import { register } from "swiper/element/bundle";
register();

// REMOVED: JM (Jul 2023) -- not sure it's used and slows Contentful Paint metrics 11ms
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   lazyComponent: true
// });
import "./registerServiceWorker";

Vue.config.productionTip = false;

// eslint-disable-next-line
import layoutEngine from "./layoutEngine.js";

// eslint-disable-next-line
import dataEngine from "./dataEngine.js";

// eslint-disable-next-line
import deckEngine from "./deckEngine.js";

// eslint-disable-next-line
import userEngine from "./userEngine.js";

// eslint-disable-next-line
import userNotifyEngine from "./userNotifyEngine.js";

// eslint-disable-next-line
import coachingEngine from "./coachingEngine.js";

// eslint-disable-next-line
import uxEngine from "./uxEngine.js";

/**
 *  Filters (formatters)
 */

Vue.filter("number", function (value) {
  if (!value) return "";
  return new Intl.NumberFormat(navigator.language, {}).format(value);
});

Vue.filter("stat", function (value) {
  if (!value) return "0";
  if (value < 10) {
    return value == Math.round(value) ? value : value.toFixed(2);
  }
  if (value > 1000) {
    return (value / 1000).toFixed(1) + "K";
  }
  if (value > 1000 * 1000) {
    return (value / (1000 * 1000)).toFixed(1) + "M";
  }
  return new Intl.NumberFormat(navigator.language, {}).format(
    Math.round(value)
  );
});

Vue.filter("round", function (value) {
  if (!value) return "";
  return new Intl.NumberFormat(navigator.language, {}).format(
    Math.round(value)
  );
});

Vue.filter("fixed", function (value) {
  if (!value) return "";
  return (+value).toFixed(2);
});

Vue.filter("abs", function (value) {
  if (!value) return "~";
  return new Intl.NumberFormat(navigator.language, {}).format(Math.abs(value));
});

Vue.filter("mood", function (value) {
  if (!value) return "";
  let v = Math.round(value * 100);
  if (v > 10) {
    return `Good news (${v}%)`;
  } else if (v > 0) {
    return `Positive (${v}%)`;
  } else if (v == 0) {
    return `Eh? (${v}%)`;
  } else if (v > -5) {
    return `Neutral? (${v}%)`;
  } else if (v > -25) {
    return `Negative? (${v}%)`;
  } else {
    return `Dark (${v}%)`;
  }
});

Vue.filter("rate", function (value) {
  if (!value) return "";
  return (
    new Intl.NumberFormat(navigator.language, {
      maximumSignificantDigits: 2,
    }).format(value * 100) + "%"
  );
});

Vue.filter("pcxupdown", function (value) {
  if (!value) return "";
  if (value < 0) {
    return (
      "▼ " +
      Math.abs(
        new Intl.NumberFormat(navigator.language, {
          maximumSignificantDigits: 2,
        }).format(value * 100)
      ) +
      "%"
    );
  } else {
    return (
      "▲ " +
      new Intl.NumberFormat(navigator.language, {
        maximumSignificantDigits: 2,
      }).format(value * 100) +
      "%"
    );
  }
});

Vue.filter("ellipsis", function (str) {
  if (!str) {
    return "";
  }
  let n = 24;
  let useWordBoundary = true;
  if (str.length <= n) {
    return str;
  }
  const subString = str.slice(0, n - 1); // the original check
  return (
    (useWordBoundary
      ? subString.slice(0, subString.lastIndexOf(" "))
      : subString) + "…"
  );
});

Vue.filter("detag", function (str) {
  if (!str) {
    return "";
  }
  return str.replace(/_/g, ' ');
});

Vue.filter("ellipsis_250", function (str) {
  if (!str) {
    return "";
  }
  let n = 250;
  let useWordBoundary = true;
  if (str.length <= n) {
    return str;
  }
  const subString = str.slice(0, n - 1); // the original check
  return (
    (useWordBoundary
      ? subString.slice(0, subString.lastIndexOf(" "))
      : subString) + "…"
  );
});

Vue.filter("ucfirst", function (value) {
  if (!value) return "";
  return value.substr(0, 1).toUpperCase() + value.substr(1);
});

Vue.filter("lcfirst", function (value) {
  if (!value) return "";
  return value.substr(0, 1).toLowerCase() + value.substr(1);
});

Vue.filter("ucwords", function (str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
});

Vue.filter("lower", function (value) {
  return (value || "").toLowerCase();
});

Vue.filter("upper", function (value) {
  return (value || "").toUpperCase();
});

Vue.filter("hyphenated", function (value) {
  if (!value) return "";
  return (value + "").replace(/\W+/g, "-").toLowerCase();
});

Vue.filter("plural", function (i, s) {
  return pluralize(s, i);
});

Vue.filter("is_are", function (i) {
  return i == 1 ? "is" : "are";
});

Vue.filter("ago", function (value, bShort) {
  // exceptions within 48h
  let iThen = new Date(value);
  let iNow = new Date();
  if (iNow.getTime() - iThen.getTime() < 48 * 60 * 60 * 1000) {
    if (iNow.getDay() == iThen.getDay()) {
      return "Today";
    } else {
      return "Yesterday";
    }
  }

  // or go with the usual format from dayjs
  if (bShort) {
    // dayjs.updateLocale('en', {
    //   relativeTime: {
    //     future: "in %s",
    //     past: "%s ago",
    //     s: 'just now',
    //     m: "just now",
    //     mm: "just now",
    //     h: "an hour",
    //     hh: "%dh",
    //     d: "a day",
    //     dd: "%dd",
    //     M: "a month",
    //     MM: "%dmon",
    //     y: "a year",
    //     yy: "%dy"
    //   }
    // });
  }
  return value ? dayjs().to(dayjs(value), bShort) : "";
});

Vue.filter("timeline", function (value, bShort) {
  // exceptions within 48h
  let iThen = new Date(value);
  let iNow = new Date();
  if (iNow.getTime() - iThen.getTime() < 48 * 60 * 60 * 1000) {
    if (iNow.getDay() == iThen.getDay()) {
      return dayjs(iThen).format("ha") == "12am"
        ? "Today"
        : dayjs(iThen).format("ha") + " today";
    } else {
      return dayjs(iThen).format("ha") == "12am"
        ? "Yesterday"
        : dayjs(iThen).format("ha") + " yesterday";
    }
  }
  return value ? dayjs().to(dayjs(value), bShort) : "";
});

Vue.filter("date", function (value) {
  return dayjs(value).format("D MMM YYYY");
});

Vue.filter("handles", function (value) {
  if (typeof value === "undefined") {
    return "";
  }

  if (value === null) {
    return "";
  }

  return value.replace(/([~@])(\w{3,})/g, (sWhole, sMarker, sHandle) => {
    // console.log({
    //   sMarker: sMarker,
    //   sHandle: sHandle,
    // });
    let sDomain = sMarker == "@" ? "https://twitter.com/" : "/~";
    // NB! Remember, this won't be css-scoped!!
    return `<a class="handle" href="${sDomain}${sHandle}">${sWhole}</a>`;
  });
});

Vue.filter("localename", function (value) {
  let oLocales = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: 'Cote D"Ivoire',
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KP: "North Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: 'Lao People"s Democratic Republic',
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russia",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "UAE",
    GB: "UK",
    US: "USA",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  };
  return value
    .toUpperCase()
    .split(",")
    .map((s) => oLocales[s])
    .join(", ");
});

/**
 * DANGER !!! DANGER !!! DANGER !!! DANGER !!! DANGER !!! DANGER !!! DANGER !!! DANGER !!! DANGER !!!
 * --------------------------------------------------------------------------------------------------
 * This fucks with ...$options.filters somehow.  Weirdly, it needs to be last, otherwise you end up
 * losing all the other filters!?
 */

import VueMq from "vue-mq";
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity, // ******* SEE layoutEngine.js for $mq parity! ********
  },
  defaultBreakpoint: "sm", // customize this for SSR
});

/**
 *          ENDS --- ENDS --- ENDS --- ENDS --- ENDS --- ENDS --- ENDS --- ENDS --- ENDS
 * --------------------------------------------------------------------------------------------------
 */

// 2025 - removed by JM... not sure it was ever used?
// import VueHtml2Canvas from 'vue-html2canvas';
// // Canvas - generating social assets
// Vue.use(VueHtml2Canvas);

router.onReady(() => {
  window.vue = new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
});

window.dataLayer = window.dataLayer || [];
